import { ccwpApi } from "@/services";

export const AdvanceSearchApi = ccwpApi.injectEndpoints({
  endpoints: (builder) => ({
    getCreditorListAttribute: builder.query<any, string | undefined>({
      query: (caseId) => {
        return {
          url: `CreditorAdvancedSearch/ListAttributes?caseId=${caseId}`,
        };
      },
    }),
    getOperatorList: builder.query<any, void>({
      keepUnusedDataFor: 60 * 60 * 8, // 8 hrs in seconds
      query: () => {
        return {
          url: `Search/ListOperators`,
        };
      },
    }),
    getCreditorAdvanceSearchData: builder.mutation({
      query: (searchData) => ({
        url: "CreditorAdvancedSearch/GetSearchResults",
        method: "POST",
        body: searchData,
      }),
    }),
    getClaimListAttribute: builder.query<any, string | undefined>({
      query: (caseId) => {
        return {
          url: `ClaimAdvancedSearch/ListAttributes?caseId=${caseId}`,
        };
      },
    }),
    getClaimAdvanceSearchData: builder.mutation({
      query: (searchData) => ({
        url: "ClaimAdvancedSearch/GetSearchResults",
        method: "POST",
        body: searchData,
      }),
    }),
    getDropDownList: builder.query<any,any>({
      query: (args) => ({
        url: args.apiEndpoint,
        method: "Get",
        params: args,
      }),
    }),
  }),
});

export const {
  useGetCreditorListAttributeQuery,
  useGetOperatorListQuery,
  useGetCreditorAdvanceSearchDataMutation,
  useGetClaimListAttributeQuery,
  useGetClaimAdvanceSearchDataMutation,
  useGetDropDownListQuery
} = AdvanceSearchApi;
